import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { BadgeWithLabel } from "@/components/BadgeMedal";
import { Award, Sparkles } from "lucide-react";

export default function StudentBadges() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/student/badges").then((r) => setData(r.data));
    // Mark badge notifications as seen for the unread red dot on the mobile More tab.
    api.post("/student/notifications/mark-seen", { source: "badges" }).catch(() => {});
  }, []);

  if (!data) return <div className="text-slate-500">Loading…</div>;
  const pct = data.total_count ? Math.round((data.earned_count / data.total_count) * 100) : 0;

  return (
    <div className="space-y-8" data-testid="student-badges-page">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600 flex items-center gap-2">
          <Award className="w-3.5 h-3.5" /> Achievements
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-1">Your Trophy Case</h1>
        <p className="text-slate-600 mt-1">Earn badges as you study, streak, and master the boards.</p>
      </div>

      <Card className="p-6 border-slate-200">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <h3 className="font-display font-bold text-lg flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-amber-500" /> Collection Progress
            </h3>
            <p className="text-sm text-slate-500 mt-0.5">{data.earned_count} of {data.total_count} badges unlocked</p>
          </div>
          <div className="text-3xl font-display font-bold text-amber-600">{pct}%</div>
        </div>
        <Progress value={pct} className="mt-4 h-3" />
      </Card>

      <Card className="p-6 border-slate-200">
        <h3 className="font-display font-bold text-lg mb-6">All Badges</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {data.badges.map((b) => (
            <BadgeWithLabel key={b.id} badge={b} />
          ))}
        </div>
      </Card>
    </div>
  );
}
